import script from "./customSupplierName.vue?vue&type=script&lang=ts&setup=true"
export * from "./customSupplierName.vue?vue&type=script&lang=ts&setup=true"

import "./customSupplierName.vue?vue&type=style&index=0&id=92081ea2&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92081ea2"]])

export default __exports__